<dgx-menu [appendToBody]="true" [menuConfig]="menuConfig" placement="bottom">
  <button
    class="skill-signal-more-button"
    df-button
    df-button-square
    dfButtonType="passive"
    data-dgat="skill-signal-more-button-526"
    role="button"
  >
    <df-icon
      icon="dots"
      a11yText="{{ 'Core_MoreOptions' | translate }}"
    ></df-icon>
  </button>
</dgx-menu>
